import {GLOBALFILTER_DATA_SUCCESS} from "@src/middleware/actions/actionTypes";

  
  interface GlobalFilterState {
    globalFilterTinData: any;
  }
  
  const initialState: GlobalFilterState = {
    globalFilterTinData: {},
  };
  
  const GlobalFilterReducer = (
    state = initialState,
    action: { type: string; payload?: any }
  ): GlobalFilterState => {
    switch (action.type) {
        case GLOBALFILTER_DATA_SUCCESS:
          return {
            ...state,
            globalFilterTinData: action.payload,
          };
      default:
        return state;
    }
  };
  
  export default GlobalFilterReducer;
  